export function parseCodeToMarkdown(blocks) {
  return `{noformat}${blocks.code}{noformat}\n`;
}
